import React, { useEffect, useState, useRef } from 'react';
import { Empty, notification } from 'antd';
import { useSelector } from 'react-redux';
import './style.scss';
import { getWeather } from '../../utils/index.js'
import moment from 'moment';
import useBluetooth from '../../hooks/useBluetooth';

const Weather = () => {
    let time = useRef('')
    const timer = useRef(null);
    const lastTriggerTime = useRef(0);
    const [isNull, setIsNull] = useState(true);
    const [standardTime, setStandardTime] = useState(moment().format('YYYY 年 MM 月 DD 日 HH:mm:ss'));
    const [inTheFuture, setInTheFuture] = useState(false);
    const bluetooth = useSelector(state => state.speaker.bluetooth);
    const [parameter, setParameter] = useState({
        city: '-',
        time: '-',
        day: '-'
    });
    const [weatherData, setWeatherData] = useState({
        text: '-',
        temp: '-',
        wind_scale: '-',
        humidity: '-',
        uv_level: '-',
        air_category: '-',
        rain: '-',
        sunrise: '-',
        sunset: '-',
        fxDate: '-',
        tempMax: '-',
        tempMin: '-',
        textDay: '-',
        textNight: '-',
        windScaleDay: '-',
        windScaleNight: '-',
        humidity: '-',
        precip: '-',
        uvIndex: '-',
    });
    const { sendMessage, setupNotifications, stopNotifications } = useBluetooth();
    
    const onMessageReceived = async (result) => {
        const data = result.find((item) => item.includes('plugin'));
        if (!data) {
            return;
        }
        const slice = data.split('//');
        console.log('')
        console.log(`命令：${slice[2]}, uid：${slice[3]}`)
        const uid = slice[3];
        if (slice.includes('is_connect_ailab')) {
            sendMessage({ [uid]: `${uid}_success` })
        }
        if (slice.includes('current_weather') || slice.includes('weather_forecast')) {
            const now = Date.now();
            if (now - lastTriggerTime.current < 500) {
                notification.error({
                    message: '错误',
                    description: '获取天气信息或天气预报每秒钟最多被触发 2 次',
                });
                return;
            }
            lastTriggerTime.current = now;
            const platform = 'lab'
            const extension_id = slice[1];
            let location = slice[4];
            let day = '0'
            if (location.includes(',')) {
                const locationSlice = location.split(',')
                location = locationSlice[0];
                day = locationSlice[1];
            }
            try {
                const res = await getWeather({
                    extension_id,
                    location,
                    platform,
                    ...(day !== '0' && { day })
                })
                if (res.success) {
                    const data = res.data;
                    const future = data.hasOwnProperty('fxDate');
                    time.current = future ? moment(data.fxDate).format('YYYY 年 MM 月 DD 日') : moment().format('YYYY 年 MM 月 DD 日 HH:mm:ss')
                    setInTheFuture(future);
                    sendMessage({ [uid]: data })
                    setIsNull(false);
                    setWeatherData(data);
                    setParameter({
                        city: location,
                        time: time.current,
                        day
                    })
                    clearInterval(timer.current);
                    timer.current = setInterval(() => {
                        setStandardTime(moment().format('YYYY 年 MM 月 DD 日 HH:mm:ss'));
                    }, 1000);

                }
            }
            catch (e) {
                sendMessage({ [uid]: `${uid}_error` })
                notification.error({
                    message: '查询天气失败',
                    description: '查询天气失败，请稍后再试',
                });
            }
        }
        if (slice.includes('getbeijingtime')) {
            const key = slice[4]
            switch (key) {
                case 'year':
                    sendMessage({ [uid]: { weathertime: `${moment().year()}` } })
                    break;
                case 'month':
                    sendMessage({ [uid]: { weathertime: `${moment().month() + 1}` } })
                    break;
                case 'day':
                    sendMessage({ [uid]: { weathertime: `${moment().date()}` } })
                    break;
                case 'hour':
                    sendMessage({ [uid]: { weathertime: `${moment().hour()}` } })
                    break;
                case 'minute':
                    sendMessage({ [uid]: { weathertime: `${moment().minute()}` } })
                    break;
                case 'second':
                    sendMessage({ [uid]: { weathertime: `${time.current.includes(':') ? time.current.split(':')[2] : moment().second()}` } })
                    break;
            }
        }
    }

    // 在组件加载时检查蓝牙连接状态并设置监听
    useEffect(() => {
        setupNotifications(onMessageReceived)
        return () => {
            clearInterval(timer.current);
            stopNotifications(onMessageReceived)
        };
    }, [bluetooth, window.location.pathname]);

    return (
        <div className='weather plug-in'>
            <div className='plug-in-name'>天气信息</div>
            <div className='plug-in-content'>
                <div className='desc-content'>
                    <div className='desc-content describe'>本扩展可在互联创作平台使用，或连接主控硬件后结合硬件编程平台使用。</div>
                </div>
                <div className='parameter'>
                    <div className='title'>当前参数</div>
                    <div className='parameter-content'>
                        <div className='parameter-item'>
                            <div className='name'>城市：</div>
                            <div className='value'>{parameter.city}</div>
                        </div>
                        <div className='parameter-item'>
                            <div className='name'>相对日期：</div>
                            <div className='value'>
                                {parameter.city === '-' ? '-':(parameter.day === '0' ? '实时天气' : `${parameter.day} 日后的天气`)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='info'>
                    <div className='title'>最近一次获取的信息</div>
                    {
                        !isNull ?
                            <div className='weather-data'>
                                <div className='time'>
                                    <span>当前中国标准时间：</span>
                                    {standardTime}
                                </div>
                                <div className='data'>
                                    <div className='city-time'>
                                        {
                                            inTheFuture ?
                                                <div><span>{parameter.city}的天气预报</span>（{parameter.time}）</div> :
                                                <div><span>{parameter.city}的实时天气信息</span>（{parameter.time}）</div>
                                        }
                                    </div>
                                    {
                                        inTheFuture ? 
                                            <div className='detail future'>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.textDay}</div>
                                                    <div className='prop-name'>预计当日白天天气状况</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.textNight}</div>
                                                    <div className='prop-name'>预计当日夜间天气状况</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.tempMax}</div>
                                                    <div className='prop-name'>预计当日最高气温</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.tempMin}</div>
                                                    <div className='prop-name'>预计当日最低气温</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.humidity}</div>
                                                    <div className='prop-name'>预计当日相对湿度（%）</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.precip}</div>
                                                    <div className='prop-name'>预计当日总降水量（mm）</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.uvIndex}</div>
                                                    <div className='prop-name'>预计当日紫外线指数</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.windScaleDay}</div>
                                                    <div className='prop-name'>预计当日白天风力等级</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.windScaleNight}</div>
                                                    <div className='prop-name'>预计当日夜间风力等级</div>
                                                </div>
                                            </div>:
                                            <div className='detail'>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.text}</div>
                                                    <div className='prop-name'>天气状况</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.temp}</div>
                                                    <div className='prop-name'>气温（℃）</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.humidity}</div>
                                                    <div className='prop-name'>相对湿度（%）</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.rain}</div>
                                                    <div className='prop-name'>降水量（mm）</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.uv_level}</div>
                                                    <div className='prop-name'>紫外线指数</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.wind_scale}</div>
                                                    <div className='prop-name'>风力等级</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.air_category}</div>
                                                    <div className='prop-name'>空气质量</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.sunrise}</div>
                                                    <div className='prop-name'>日出时间</div>
                                                </div>
                                                <div className='item'>
                                                    <div className='value'>{weatherData.sunset}</div>
                                                    <div className='prop-name'>日落时间</div>
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div> :
                            <div className='empty'>
                                <Empty description="暂未获取过信息" />
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}
export default Weather;